<div class="dialog-container">
  <div class="dialog-header">
    <p class="unvoid-title">{{ 'ADD_VOID_DISH.UNVOID_DISH' | translate }}</p>
  </div>
  <div class="dialog-body">
    <p class="unvoid-desc">
      {{ 'ADD_VOID_DISH.ARE_YOU_SURE_WANT_TO_UNVOID_DISH' | translate }}
    </p>
    <div class="flex_sb qty-control-group">
      <p class="unvoid-qty">
        {{ 'ADD_VOID_DISH.ENTER_QTY_TO_UNVOID' | translate }}
      </p>
      <div class="flex_sb ta_center">
        <button
          class="decrement-qty btn-group"
          nz-button
          nzType="default"
          (click)="modifyUnvoidQty('decrement')"
          [disabled]="unvoidedItemQty <= 1"
        >
          <i nz-icon nzType="minus"></i>
        </button>
        <span class="qty-display btn-group">{{ unvoidedItemQty }}</span>
        <button
          class="increment-qty btn-group"
          nz-button
          nzType="default"
          (click)="modifyUnvoidQty('increment')"
          [disabled]="unvoidedItemQty === totalVoidItems"
        >
          <i nz-icon nzType="plus"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="dialog-footer flex_sb">
    <button class="btn cancel-btn" (click)="cancelBtnClikced()">
      {{ 'ADD_VOID_DISH.CANCEL' | translate }}
    </button>
    <button class="btn unvoid-btn" (click)="unvoidDishClicked()">
      {{ 'ADD_VOID_DISH.UNVOID_DISH' | translate }}
    </button>
  </div>
</div>
